export default __webpack_public_path__ + "static/media/soja_r4.f0188755.png";